import { render, staticRenderFns } from "./Aneel11_ParecerAvaliacao.vue?vue&type=template&id=553ebda6&"
import script from "./Aneel11_ParecerAvaliacao.vue?vue&type=script&lang=js&"
export * from "./Aneel11_ParecerAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports